import { FC, useState } from "react";

import { ArrowForwardIos, DeleteForever, DeleteForeverOutlined, LooksOneOutlined, LooksTwoOutlined, Sell, TextFields, Bookmark} from "@mui/icons-material";
import { Entity } from "../objects/Entity.interface";
import { Annotation } from '../objects/Annotation.interface';
import React from "react";
import ContextMenu_EntityFields from "./ContextMenu_EntityFields";
import { AnnotationService } from "../services/Annotations.service";
import { basicFormatString, getDuplicateUniquesAnnotations } from "../tools/Utils";
import { Checkbox } from "@mui/material";
import { PlaceNameStats } from "../objects/PlaceNameStats.interface";


interface ContextMenuProps {
    x:number|undefined
    y:number|undefined
    displayValue:string|undefined
    xTranslate:string|undefined
    yTranslate:string|undefined
    contextMenuOutScreen: (onclick:boolean) => void
    closeContextMenu: () => void
    showAnnotations: ()=> void
    updateDocumentStats: () => void
    refreshData: () => void
    entities: Entity[],
    annotation:Annotation,
    annotationList:Annotation[]
}

const ContextMenu:FC<ContextMenuProps> = ({x,y,displayValue, xTranslate, yTranslate, contextMenuOutScreen,closeContextMenu, showAnnotations,updateDocumentStats, refreshData, entities, annotationList, annotation}) => {
 
   

    const [filterValue, setFilterEntities] = useState('');
    const _annotationsService = new AnnotationService();
    var annotationsToSave:Annotation[] = [];


    function handleFilterEntities(e:any){
        setFilterEntities(e.target.value);
    }

    function clearEntity(entityIndex:number){
        
        if(annotationsToSave.length > 0 && !annotation.isUniqueMode){
            if(entityIndex === 0 ){
                annotationsToSave.forEach(annSelected => {
                    if(!annSelected.isUniqueMode){
                        annSelected.firstEntityId =  -1;
                        annSelected.firstEntityCode = '';
                        annSelected.fieldsFirstEntity =  [];

                        if(annSelected.secondEntityId >= 0){
                            annSelected.firstEntityId =  annSelected.secondEntityId;
                            annSelected.firstEntityCode = annSelected.secondEntityCode;
                            annSelected.fieldsFirstEntity =  annSelected.fieldsSecondEntity;

                            annSelected.secondEntityId =  -1;
                            annSelected.secondEntityCode = '';
                            annSelected.fieldsSecondEntity =  [];
                        }else
                        {
                            annSelected.status = 'Draft';
                        }
                    }
                });
            }
            else
            {
                annotationsToSave.forEach(annSelected => {
                    if(!annSelected.isUniqueMode){
                        annSelected.secondEntityId =  -1;
                        annSelected.secondEntityCode = '';
                        annSelected.fieldsSecondEntity =  [];
                    }
                });
            }
            updateBulkAnnotations();
        }else
        {
            //borrado de entidades de anotacion unica
            var annnotationToUpdate =  getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate)
                {
                    if(entityIndex === 0){
                        annnotationToUpdate.forEach(annSelected => {
                            annSelected.firstEntityId =  -1;
                            annSelected.firstEntityCode =  '';
                            annSelected.fieldsFirstEntity =  [];
                        
                        if(annSelected.secondEntityId >= 0){
                            annSelected.firstEntityId =  annSelected.secondEntityId;
                            annSelected.firstEntityCode = annSelected.secondEntityCode;
                            annSelected.fieldsFirstEntity =  annSelected.fieldsSecondEntity;

                            annSelected.secondEntityId =  -1;
                            annSelected.secondEntityCode = '';
                            annSelected.fieldsSecondEntity =  [];
                        }else
                        {
                            annSelected.status = 'Draft';
                        }

                        updateAnnotation(annSelected);

                    });

                    }else if(entityIndex === 1){
                        annnotationToUpdate.forEach(annSelected => {
                        annSelected.secondEntityId =  -1;
                        annSelected.secondEntityCode =  '';
                        annSelected.fieldsSecondEntity =  [];
                        updateAnnotation(annSelected);
                    });
                        
                    }
                    
                }

        }
        
    }

    function setDraftStatus () {
      
        if(!annotation.isUniqueMode){
            if(annotationsToSave.length > 0){
                annotationsToSave.forEach(annSelected => {
                    annSelected.status = 'Draft';
                });
                updateBulkAnnotations();
            }
        }
        else{
            var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);
            annnotationToUpdate.forEach(annSelected => {
                annSelected.status = 'Draft';
                updateAnnotation(annSelected);
            });
        }
        
    }

    function deleteBulkAnnotations()
    {
        
        var annKeysToDelete:number[] = [];
        annotationsToSave = filterAnnotations(annotationList);
        annKeysToDelete = annotationsToSave.map(annSelected => annSelected.id!);
  
        var result = _annotationsService.deleteBulk(annKeysToDelete);
        result.then(result => {
            updateDocumentStats();
            closeContextMenu();
            showAnnotations();
        });
    }

    function setUniqueAnnotation(){
        annotation.isUniqueMode = !annotation.isUniqueMode;
        var result = _annotationsService.update(annotation);
        result.then(result => {
            showAnnotations();

        });
    }

    function deleteUniqueAnnotation()
    {
        var annotationsToDelete = annotationList.filter(item => item.text === annotation.text && item.start === annotation.start && item.end === annotation.end && item.paragraph === annotation.paragraph || item.id == annotation.relatedTo);
        var annotationToDeleteKeys = annotationsToDelete.map(annSelected => annSelected.id!); 

        var result = _annotationsService.deleteBulk(annotationToDeleteKeys);
        result.then(result => {
            updateDocumentStats();
            closeContextMenu();
            showAnnotations();
        });
    }

    function updateBulkAnnotations()
    {
        var result = _annotationsService.updateBulk(annotationsToSave);
        result.then(result => {
            updateDocumentStats();
            refreshData();
            //comunicar con el componente de anotador
        });
    }

    function updateAnnotation(annotation:Annotation)
    {
        var result = _annotationsService.update(annotation);
        result.then(result => {
            updateDocumentStats();
            refreshData();
            //comunicar con el componente de anotador
        });
    }

    function updateFirstEntityData(entity:Entity){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
                annotationsToSave.forEach(annSelected => {
                    if(!annSelected.isUniqueMode){
                        annSelected.firstEntityId =  entity.id!
                        annSelected.firstEntityCode =  entity.Code;
                        annSelected.fieldsFirstEntity =  [];
                    }
                });
                updateBulkAnnotations();
            }
            else
            {
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                    annSelected.firstEntityId =  entity.id!
                    annSelected.firstEntityCode =  entity.Code;
                    annSelected.fieldsFirstEntity =  [];
                    updateAnnotation(annSelected);
                    });
                }
            }
        }
    }

    function updateSecondEntityData(entity:Entity){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
                annotationsToSave.forEach(annSelected => {
                    if(!annSelected.isUniqueMode){
                        annSelected.secondEntityId =  entity.id!
                        annSelected.secondEntityCode = entity.Code;
                        annSelected.fieldsSecondEntity =  [];
                    }
                });
                updateBulkAnnotations();
            }
            else
            {
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation); 

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                    annSelected.secondEntityId =  entity.id!
                    annSelected.secondEntityCode =  entity.Code;
                    annSelected.fieldsSecondEntity =  [];
                    updateAnnotation(annSelected);
                    });
                }
            }
        }
    }

    
    function entitySelected(entity:Entity, entityIndex:number){
        annotationsToSave = filterAnnotations(annotationList);
        /*
        if(annotation.status === 'Saved')
            annotationsToSave = annotationList.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) === basicFormatString(annotation.text));
        else
            annotationsToSave = annotationList.filter((tmpAnnotation) =>  tmpAnnotation.status === 'Draft');
        */
    
        if(entityIndex == 0)
        {
            updateFirstEntityData(entity);
        }
        else if(entityIndex == 1)
        {
            updateSecondEntityData(entity);
        }
        //closeContextMenu();
    }

    function getEntityName(entityId:number):string{
        var entityFounded =  entities.find((entity) => entity.id == entityId);

        if(entityFounded)
            return entityFounded?.Entity;
        else
            return 'undefined';

    }

    function getEntityById(entityId:number):Entity|undefined{
        var entityFounded =  entities.find((entity) => entity.id == entityId);
        return entityFounded;
    }

    function getFieldName(entityId:number,fields:string[],fieldIndex:number):string{
        var fieldName:string = (fieldIndex == 0)?"First field":"Second field";

        const entity = getEntityById(entityId);
        if(entity && fields.length >= 1 && fieldIndex == 0 ){
            const fieldFounded = entity.FieldList!.find((field) => field.code == fields[fieldIndex]);
            if(fieldFounded)
            {
                fieldName = fieldFounded.name;
            }
        }

        if(entity && fields.length == 2 && fieldIndex == 1 ){
            const fieldFounded = entity.FieldList!.find((field) => field.code == fields[fieldIndex]);
            if(fieldFounded)
            {
                fieldName = fieldFounded.name;
            }
        }
        return fieldName;
    }

    function filterSelectedEntity(entities:Entity[]):Entity[]{
        var tmpEntities = entities.filter((entity) => entity.Code !== annotation.secondEntityCode);

        return tmpEntities.filter((entity) => entity.Code !== annotation.firstEntityCode);;
    }

    function filterAnnotations(annotations:Annotation[]){
        var newAnnotationsToSave = [];
        if(annotation.relatedTo != -1){
            var annotationRelatedFilter =  annotations.filter(item => item.id == annotation.relatedTo);
            if(annotationRelatedFilter.length > 0){
                var annotationRelated = annotationRelatedFilter[0];
                var paragraphSelectedAnnotation =  parseInt(annotation.paragraph.split('p')[1]);
                var paragraphRelatedAnnotation =  parseInt(annotationRelated.paragraph.split('p')[1]);
    
                var textContentWithSpace = '';
                var textContentWithoutSpace = '';
                if(paragraphRelatedAnnotation > paragraphSelectedAnnotation){
                    textContentWithSpace = annotation.text + ' ' + annotationRelated.text;
                    textContentWithoutSpace = annotation.text + annotationRelated.text;
                }else
                {
                    textContentWithSpace = annotationRelated.text + ' ' + annotation.text;
                    textContentWithoutSpace = annotationRelated.text + annotation.text;
                }
    
                newAnnotationsToSave = annotations.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) === basicFormatString(textContentWithSpace) || 
                basicFormatString(tmpAnnotation.text) === basicFormatString(textContentWithoutSpace) || 
                basicFormatString(tmpAnnotation.relatedText) === basicFormatString(annotation.relatedText) ||
                tmpAnnotation.id == annotation.id ||
                tmpAnnotation.id == annotationRelated.id);
            }else{
                newAnnotationsToSave = annotations.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) === basicFormatString(annotation.text) || basicFormatString(tmpAnnotation.relatedText).replaceAll(' ','') === basicFormatString(annotation.text).replaceAll(' ',''));
            }
            

        }else{
            newAnnotationsToSave = annotations.filter((tmpAnnotation) => basicFormatString(tmpAnnotation.text) === basicFormatString(annotation.text) || basicFormatString(tmpAnnotation.relatedText).replaceAll(' ','') === basicFormatString(annotation.text).replaceAll(' ',''));
        }

        return newAnnotationsToSave;
    }

    function getAnnTextToShow():string{
       
            if(annotation.relatedTo != -1){
              return annotation.relatedText;
            }else
            {
              return annotation.text;
            }
    }

    function menuEventHandler(event:string){
        switch(event){
            case 'ClearAllEntities':
                annotationsToSave = filterAnnotations(annotationList); 
                clearEntity(1); 
                clearEntity(0); 
                setDraftStatus();
                break;
            case 'ClearFirstEntity':
                annotationsToSave = filterAnnotations(annotationList); 
                clearEntity(0);
                break;
            case 'ClearSecondEntity':
                annotationsToSave = filterAnnotations(annotationList); 
                clearEntity(1);
                break;
        }
    }

    
    return (
        
        <ul
        id="contextMenu"
        onMouseOver={(e) => {contextMenuOutScreen(false);}}
        onMouseLeave={(e) => {contextMenuOutScreen(false);}}
        className="context-menu-absolute"
        style={
            x !== undefined
                ? {top: `${y}px`, left: `${x}px`, transform: `translate(${xTranslate}, ${yTranslate})`, display: displayValue}
                :undefined
        }>
            <li  className="context-menu-item context-menu-label"><span>Unique Annotation</span> <Checkbox size="small" checked={annotation.isUniqueMode} onClick={(e) => setUniqueAnnotation()} className="annotation-unique-checkbox"/> <Bookmark className="context-menu-item-icon"></Bookmark></li>
            <li  className="context-menu-item context-menu-label context-menu-line"><span>{getAnnTextToShow()}</span> <TextFields className="context-menu-item-icon"></TextFields></li>
            <li onClick={deleteBulkAnnotations} className="context-menu-item context-menu-label"><span>Delete All Annotations</span> <DeleteForever className="context-menu-item-icon"></DeleteForever></li>
            <li onClick={deleteUniqueAnnotation} className="context-menu-item context-menu-label context-menu-line"><span>Delete this Annotation</span> <DeleteForever className="context-menu-item-icon"></DeleteForever></li>
            <li onClick={(e) => {e.stopPropagation(); menuEventHandler('ClearAllEntities');}} className="context-menu-item context-menu-label"><span>Clear All Entities</span> <DeleteForeverOutlined className="context-menu-item-icon"></DeleteForeverOutlined></li>

            {
                <li  className="context-menu-item">
                    <span onMouseOver={(e) => {contextMenuOutScreen(false);}}>{getEntityName(annotation.firstEntityId)}<ArrowForwardIos className="context-menu-item-arrow"></ArrowForwardIos></span>
                    <LooksOneOutlined className="context-menu-item-icon"></LooksOneOutlined>
                    <ul onMouseOver={(e) => {contextMenuOutScreen(false);}} id="submenu-first-submenu" className="context-submenu">
                        <li className="context-submenu-item context-submenu-default-cursor" style={{
                                        display: (annotation.firstEntityId == -1) ? 'none':'flex'
                                    }} onClick={(e) => {e.stopPropagation(); menuEventHandler('ClearFirstEntity');}}>
                            <span> Clear Entity<DeleteForeverOutlined className="context-menu-item-icon"></DeleteForeverOutlined></span>
               
                        </li>
                        <li className="context-submenu-item context-submenu-default-cursor" style={{
                                        display: (annotation.firstEntityId == -1) ? 'none':'flex'
                                    }}>
                            <span>{getFieldName(annotation.firstEntityId,annotation.fieldsFirstEntity!,0)} <Sell className="context-menu-item-icon"></Sell></span>
                            <ArrowForwardIos className="context-menu-item-arrow"></ArrowForwardIos>
                            <ContextMenu_EntityFields menuFieldId={'submenufield-first-submenu'} entities={entities} entityId={annotation.firstEntityId} fieldIndex={0} fieldSelected={0} annotation={annotation} annotationList={annotationList} closeContextMenu={closeContextMenu} refreshData={refreshData} filterAnnotationsToSave={filterAnnotations} updateDocumentStats={updateDocumentStats}/>
                        </li>
                        <li className="context-submenu-item context-submenu-default-cursor context-menu-line" style={{
                                        display: (annotation.fieldsFirstEntity!.length ==  0) ? 'none':'flex'
                                    }}>
                            <span>{getFieldName(annotation.firstEntityId,annotation.fieldsFirstEntity!,1)} <Sell className="context-menu-item-icon"></Sell></span>
                            <ArrowForwardIos className="context-menu-item-arrow"></ArrowForwardIos>
                            <ContextMenu_EntityFields menuFieldId={'submenufield-first-submenu'} entities={entities} entityId={annotation.firstEntityId} fieldIndex={1} fieldSelected={0} annotation={annotation} annotationList={annotationList} closeContextMenu={closeContextMenu} refreshData={refreshData}  filterAnnotationsToSave={filterAnnotations} updateDocumentStats={updateDocumentStats}/>
                        </li>
                        {   
                            <li className="context-submenu-item context-submenu-default-cursor context-menu-line" style={{
                                display: ( annotation.firstEntityId == -1) ? 'flex':'none'
                            }}>
                                <span className="context-submenu-item-disabled">{getFieldName(annotation.firstEntityId,annotation.fieldsFirstEntity!,0)} <Sell className="context-menu-item-icon context-submenu-item-disabled"></Sell></span>
                                <ArrowForwardIos className="context-menu-item-arrow context-submenu-item-disabled"></ArrowForwardIos>
                            </li>
                        }
                        {   
                            <li className="context-submenu-item context-submenu-default-cursor context-menu-line" style={{
                                display: ( annotation.fieldsFirstEntity!.length >= 1) ? 'none':'flex'
                            }}>
                                <span className="context-submenu-item-disabled">{getFieldName(annotation.firstEntityId,annotation.fieldsFirstEntity!,1)} <Sell className="context-menu-item-icon context-submenu-item-disabled"></Sell></span>
                                <ArrowForwardIos className="context-menu-item-arrow context-submenu-item-disabled"></ArrowForwardIos>
                            </li>
                        }
                        <input autoComplete="off" onChange={(e)=> {handleFilterEntities(e);}} className="context-menu-search-item" placeholder="Search"  id="site-search-second" name="q" />
                        <div className="context-menu-container-options"> 
                        {
                            filterSelectedEntity(entities).filter((entity) => entity.Entity.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase())).map((entity) => {
                                return (
                                <li className="context-submenu-item"
                                onClick={(e) => {e.stopPropagation(); entitySelected(entity, 0);}}
                                >
                                     <div className="area-entity-circle-context-menu" style={{background: entity.Color}}></div>

                                    <span >
                                        {entity.Entity}
                                    </span>
                                </li>)
                                
                            })
                        }
                        </div>
                    </ul>
                </li>
            }
            {
                
                <li className="context-menu-item" style={{
                    display: (annotation.firstEntityId == -1) ? 'none':'flex'
                }}>
                    
                    <span onMouseOver={(e) => {contextMenuOutScreen(false);}}>{getEntityName(annotation.secondEntityId)} <ArrowForwardIos className="context-menu-item-arrow"></ArrowForwardIos></span>
                    <LooksTwoOutlined className="context-menu-item-icon"></LooksTwoOutlined>
                    <ul onMouseOver={(e) => {contextMenuOutScreen(false);}} id="submenu-second-submenu" className="context-submenu">
                        
                           
                        <li className="context-submenu-item" style={{
                                display: (annotation.secondEntityId == -1) ? 'none':'flex'
                            }} onClick={(e) => {e.stopPropagation(); menuEventHandler('ClearSecondEntity');}}>
                        <span>Clear Entity<DeleteForeverOutlined className="context-menu-item-icon"></DeleteForeverOutlined></span>
                        </li>
                    
                        <li className="context-submenu-item context-submenu-default-cursor"  style={{
                                        display: (annotation.secondEntityId == -1) ? 'none':'flex'
                                    }}>
                            <span>{getFieldName(annotation.secondEntityId,annotation.fieldsSecondEntity!,0)} <Sell className="context-menu-item-icon"></Sell></span>
                            <ArrowForwardIos className="context-menu-item-arrow"></ArrowForwardIos>
                            <ContextMenu_EntityFields menuFieldId={'submenufield-second-submenu'} entities={entities} entityId={annotation.secondEntityId} fieldIndex={0} fieldSelected={1} annotation={annotation} annotationList={annotationList} closeContextMenu={closeContextMenu} refreshData={refreshData} filterAnnotationsToSave={filterAnnotations} updateDocumentStats={updateDocumentStats}/>

                            
                        </li>
                        <li className="context-submenu-item context-submenu-default-cursor context-menu-line" style={{
                                        display: (annotation.fieldsSecondEntity!.length ==  0) ? 'none':'flex'
                                    }}>
                            <span>{getFieldName(annotation.secondEntityId,annotation.fieldsSecondEntity!,1)} <Sell className="context-menu-item-icon"></Sell></span>
                            <ArrowForwardIos className="context-menu-item-arrow"></ArrowForwardIos>
                            <ContextMenu_EntityFields menuFieldId={'submenufield-second-submenu'} entities={entities} entityId={annotation.secondEntityId} fieldIndex={1} fieldSelected={1} annotation={annotation} annotationList={annotationList} closeContextMenu={closeContextMenu} refreshData={refreshData} filterAnnotationsToSave={filterAnnotations} updateDocumentStats={updateDocumentStats}/>
                        </li>
                        {   
                            <li className="context-submenu-item context-submenu-default-cursor context-menu-line" style={{
                                display: (annotation.secondEntityId == -1) ? 'flex':'none'
                            }}>
                                <span className="context-submenu-item-disabled">{getFieldName(annotation.firstEntityId,annotation.fieldsSecondEntity!,0)} <Sell className="context-menu-item-icon context-submenu-item-disabled"></Sell></span>
                                <ArrowForwardIos className="context-menu-item-arrow context-submenu-item-disabled"></ArrowForwardIos>
                            </li>
                        }
                        {   
                            <li className="context-submenu-item context-submenu-default-cursor context-menu-line" style={{
                                display: (annotation.fieldsSecondEntity!.length >= 1) ? 'none':'flex'
                            }}>
                                <span className="context-submenu-item-disabled">{getFieldName(annotation.firstEntityId,annotation.fieldsSecondEntity!,1)} <Sell className="context-menu-item-icon context-submenu-item-disabled"></Sell></span>
                                <ArrowForwardIos className="context-menu-item-arrow context-submenu-item-disabled"></ArrowForwardIos>
                            </li>
                        }
                        <input autoComplete="off" onChange={(e)=> {handleFilterEntities(e);}} className="context-menu-search-item" placeholder="Search"  id="site-search" name="q" />
                        <div className="context-menu-container-options">
                        {
                            filterSelectedEntity(entities).filter((entity) => entity.Entity.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase())).map((entity) => {
                                return (
                                    <li 
                                    className="context-submenu-item"
                                    onClick={(e) => {e.stopPropagation(); entitySelected(entity, 1);}}
                                    >
                                        <div className="area-entity-circle-context-menu" style={{background: entity.Color}}></div>
                                        <span>{entity.Entity}</span>
                                </li>)
                            })
                        }
                        </div>
                    </ul>
                </li>
                
            }
            {   
                <li className="context-menu-item" style={{
                    display: (annotation.firstEntityId > -1) ? 'none':'flex'
                }}>
                    <span className="context-menu-item-disabled"> {getEntityName(annotation.secondEntityId)} </span>
                    <LooksTwoOutlined className="context-menu-item-icon context-menu-item-disabled"></LooksTwoOutlined>
                </li>
            }
        </ul>  
    )
}

export default ContextMenu